export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M13 22v-6h3l-4-4-4 4h3v6H5.99C4.89 22 4 21.1 4 20l.01-16c0-1.1.89-2 1.99-2h8l6 6v12c0 1.1-.9 2-2 2zm0-18.5L18.5 9H13z\"/>"
};